import { render } from "./Databases.vue?vue&type=template&id=584095b4"
import script from "./Databases.vue?vue&type=script&lang=js"
export * from "./Databases.vue?vue&type=script&lang=js"
script.render = render

export default script